import styled, { css } from "styled-components";
import { Props } from "react-select";
import CustomSelectProps from "./Select.types";

const SelectWrapper = styled.div<Props & CustomSelectProps>`
    .bw-react-select__control {
        box-shadow: none;
        max-width: 100%;
        background-color: transparent;
        border: solid 1px ${(props) => props.theme.colors["white.50"]};
        border-radius: ${(props) => props.theme.elements.form.input.borderRadius};
        background: transparent;
        width: ${({ width }) => `${width ? `${width}px` : "100%"}`};
        height: ${({ height }) => height && `${height}px`};
        font-size: ${({ fontSize }) => fontSize && `${fontSize}px`};
        padding: 0 12px;
        min-height: 30px;
        cursor: pointer;

        ${({ variant }) => variant === "button" && css`
            box-shadow: 0 3px 3px 0 ${({ theme }) => theme.colors["black.25"]};
            background-color: ${({ theme }) => theme.colors["white.100"]};
            color: ${({ theme }) => theme.colors["black.100"]};
        `};

        ${({ error }) => error && css`
            border-color: ${(props) => props.theme.colors.error.strong};
        `};

        &:hover {
            background-color: ${(props) => props.theme.colors["white.10"]};

            ${({ variant }) => variant === "button" && css`
                background-color: ${({ theme }) => theme.colors.blue.light}; // #bfccff
                box-shadow: 0 3px 12px 0 ${({ theme }) => theme.colors["black.50"]};
                border-color: transparent;
            `};

            ${({ error }) => error && css`
                border-color: ${(props) => props.theme.colors.error.strong};
            `};
        }

        &:active {
            ${({ variant }) => variant === "button" && css`
                background-color: ${({ theme }) => theme.colors.blue.base}; //#8099fc
                border-color: transparent !important;
                box-shadow: 0 0 12px 0 ${({ theme }) => theme.colors["black.25"]};
            `};
        }

        &--is-focused {
            border-color: ${(props) => props.theme.colors.blue.light};
            color: ${(props) => props.theme.colors["white.100"]};
            box-shadow: ${(props) => props.theme.colors.blue.light} 0px 0px 0px 1px;

            ${({ variant }) => variant === "button" && css`
                background-color: ${({ theme }) => theme.colors["white.100"]}; //#fff
                box-shadow: 0 0 12px 0 ${({ theme }) => theme.colors["black.25"]};
                border-color: transparent;
            `};

            ${({ error }) => error && css`
                border-color: ${(props) => props.theme.colors.error.strong};
                box-shadow: ${(props) => props.theme.colors.error.strong} 0px 0px 0px 1px;
            `};

            &:hover {
                border-color: ${(props) => props.theme.colors.blue.light};

                ${({ error }) => error && css`
                    border-color: ${(props) => props.theme.colors.error.strong};
                `};
            }
        }

        &--menu-is-open {
            & .bw-react-select__indicator {
                transform: rotate(180deg);
            }
        }

        &--is-disabled {
            color: ${(props) => props.theme.colors["white.25"]} !important;
            border-color: ${(props) => props.theme.colors["white.25"]};
            background-color: rgba(255, 255, 255, 0);
            pointer-events: none;
            user-select: none;
            .bw-react-select__single-value,
            .bw-react-select__placeholder,
            .bw-react-select__indicator {
                color: ${(props) => props.theme.colors["white.25"]};
                font-weight: ${(props) => props.theme.typography.weights[300]};
                
                ${({ variant }) => variant === "button" && css`
                    font-weight: ${(props) => props.theme.typography.weights[400]};
                `};
            }
        }
    }

    .bw-react-select__value-container {
        padding: 0;
    }

    .bw-react-select__single-value {
        margin: 0;
        color: white;
        font-weight: ${(props) => props.theme.typography.weights[300]};
        
        ${({ variant }) => variant === "button" && css`
            color: ${(props) => props.theme.colors["black.100"]};
            font-weight: ${(props) => props.theme.typography.weights[400]};
        `};

        ${({ error }) => error && css`
            color: ${(props) => props.theme.colors.error.strong};
        `};
    }

    .bw-react-select__placeholder {
        margin: 0;
        color: ${(props) => props.theme.colors["white.50"]};
        font-weight: ${(props) => props.theme.typography.weights[300]};
        
        ${({ variant }) => variant === "button" && css`
            color: ${(props) => props.theme.colors["black.100"]};
            font-weight: ${(props) => props.theme.typography.weights[400]};
        `};

        ${({ error }) => error && css`
            color: ${(props) => props.theme.colors.error.strong};
        `};
    }

    .bw-react-select__input {
        color: white !important;

        &-container {
            padding: 0;
        }
    }

    .bw-react-select__indicators { }

    .bw-react-select__indicator-separator { }

    .bw-react-select__indicator {
        padding: 0;
        color: white;

        ${({ variant }) => variant === "button" && css`
            color: ${(props) => props.theme.colors["black.100"]};
        `};

        ${({ error }) => error && css`
            color: ${(props) => props.theme.colors.error.strong};
        `};
    }

    .bw-react-select__menu {
        background-color: ${(props) => props.theme.colors["black.100"]};
        margin-top: 4px;
        margin-bottom: 4px;
        box-shadow: 0;
        border: 1px solid ${(props) => props.theme.colors["white.50"]};
    }

    .bw-react-select__menu-list {
        padding: 0;
    }

    .bw-react-select__option {
        cursor: pointer;
        color: white;
        font-size: ${({ fontSize }) => `${fontSize ? fontSize : 14}px`};
        font-weight: ${(props) => props.theme.typography.weights[300]};

        &--is-focused:not(&--is-selected) {
            background-color: #313131;
            color: white;
        }

        &--is-selected {
            background-color: #bfccff;
            color: black;
        }
    }
`;

export { SelectWrapper };
